import AppHeadingTextBlock from './AppHeadingTextBlock.vue';

export default AppHeadingTextBlock;



// WEBPACK FOOTER //
// ./src/uikit/components/AppHeadingTextBlock/index.ts